import { Movimiento } from "./movimiento";
import { Bodega } from "./bodega";
import { Usuario } from "./usuario";
import { AsientoContable } from "./asiento-contable";

export class AjusteInventario {
    public constructor(
        public id: String = "",
        public tipo :string = "",
        public fecha_ajuste: string = "",
        public movimiento_id: String = "",
        public bodega_id: String = "",
        public concepto: String = "",

        public movimiento: Movimiento = new Movimiento(),
        public bodega: Bodega = new Bodega(),
        public usuario: Usuario = new Usuario(),
        public asientosContables: Array<AsientoContable> = [],
    ){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/ajuste-inventario.ts